// Vue
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
// Template
import template from "./template.vue";
// Base Module
// Components
import { Observer } from "mobx-vue";
import { AbhHandlersuche } from "../../../common/interfaces/unimog/AbhHandlersuche";
import H from "@mgs/ci2019-common/src/components/shared/map/heremaps/mapsjs.bundle.js";

@Observer
@Component({
  mixins: [template],
  components: {},
})
export class Map extends Vue {
  @Prop({ default: () => [] })
  public points!: H.geo.IPoint[];

  @Prop()
  public myLocation!: H.geo.Point;

  @Prop()
  public selectedHaendler!: any;

  @Prop()
  public abh!: AbhHandlersuche;

  @Prop()
  public language!: string;

  private platform!: H.service.Platform;

  private map!: H.Map;

  private clusteredDataProvider: any = null;

  private selectedPoints: any = null;

  private myLocationMarker: H.map.Marker | null = null;

  private noiseSvg =
    '<svg version="1.1" id="{id}" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"\n' +
    '\t viewBox="0 0 362.1 512" style="enable-background:new 0 0 362.1 512;" xml:space="preserve" class="noise-icon">\n' +
    '<style type="text/css">\n' +
    "\t.st0{fill:#333333;}\n" +
    "\t.st1{fill:#FFFFFF;}\n" +
    "</style>\n" +
    '<path class="st0" d="M362.1,180C362.1,80.6,281,0,181,0S0,80.6,0,180c0,86.9,62,159.4,144.4,176.3L181,512l36.7-155.7\n' +
    '\t\t\tC300.1,339.4,362.1,266.9,362.1,180z"/>\n' +
    '<text class="st1 noise-icon__text" x="181" y="230" text-anchor="middle" font-family="Arial" font-weight="bold" font-size="160" style="fill: #FFFFFF">{text}</text>\n' +
    "</svg>";

  private abhMarkerSvg =
    '<svg version="1.1" id="Ebene_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 362 512" x="0px" y="0px" width="362" height="512">\n' +
    "<style>\n" +
    ".st0{fill:#333}\n" +
    "</style>\n" +
    '<path class="st0" d="M362 180C362 81 281 0 181 0S0 81 0 180c0 87 62 159 144 176l37 156 37-156c82-17 144-89 144-176z"/>\n' +
    '<circle cx="181" cy="181" r="155" fill="#fff"/>\n' +
    '<path class="st0" d="M175 130l-11 34h-36l-4 12 29 21-11 34 10 8 29-22 29 22 10-8-11-34 29-21-3-12h-37l-11-34z"/>\n' +
    "</svg>";

  private currentAbhMarker: H.map.Marker | null = null;

  @Watch("points")
  public onPointsChange(newVal, oldVal) {
    this.clusteredDataProvider.setDataPoints(newVal);
  }

  @Watch("myLocation")
  public onMyLocationChange(newVal, oldVal) {
    if (this.myLocationMarker !== null) {
      this.map.removeObject(this.myLocationMarker);
      this.myLocationMarker = null;
    }

    if (newVal !== null && this.map) {
      var svg =
        '<svg class="wb-e-btn-20__icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" height="32" width="32"><defs><style>.cls-1{fill:#00adef;}</style></defs><path class="cls-1" d="M32,14.515H29.5A13.559,13.559,0,0,0,17.485,2.492V0h-2.9V2.491A13.6,13.6,0,0,0,2.5,14.515H0v2.9H2.487a13.6,13.6,0,0,0,12.1,12.1V32h2.9V29.5A13.6,13.6,0,0,0,29.513,17.411H32ZM16.037,26.506A10.506,10.506,0,1,1,26.543,16,10.552,10.552,0,0,1,16.037,26.506Z"/><circle class="cls-1" cx="16" cy="16" r="4.9"/></svg>';
      var icon = new H.map.Icon(svg, {
        size: { w: 32, h: 32 },
        anchor: { x: 16, y: 16 },
        crossOrigin: false,
      });
      this.myLocationMarker = new H.map.Marker(newVal, { icon: icon });
      this.map.addObject(this.myLocationMarker);

      var nearest = this.findNearestPoint(newVal);
      if (nearest) {
        this.map.addEventListener(
          "mapviewchangestart",
          this.zoomOutMapAfterLocationChanged
        );
        this.map.getViewModel().setLookAtData({
          bounds: H.geo.Rect.coverPoints([nearest, newVal]).resizeToCenter(
            newVal
          ),
        });
      } else {
        this.map.setCenter({
          lat: newVal.lat,
          lng: newVal.lng,
        });
        this.map.setZoom(12);
      }
    }
  }

  @Watch("selectedHaendler")
  public onSelectedHaendlerChange(point) {
    setTimeout(() => {
      this.map.getViewPort().resize();
    }, 100);

    Array.from(document.getElementsByClassName("noise-icon")).forEach(
      (elem) => {
        elem.classList.remove("active");
      }
    );
    if (point !== null) {
      let elem = document.getElementById("haendler-" + point.data.id);
      if (elem) {
        elem.classList.add("active");
      }

      var w = Math.max(
        document.documentElement.clientWidth,
        window.innerWidth || 0
      );
      if (w < 768) {
        this.map.setCenter({
          lat: point.data.location.lat,
          lng: point.data.location.lng,
        });
      }
    }
  }

  @Watch("abh")
  public onAbhChange() {
    if (this.abh) {
      var abhMarkerIcon = new H.map.Icon(this.abhMarkerSvg, {
        size: { w: 28, h: 40 },
        crossOrigin: false,
      });

      var abhMarker = new H.map.Marker(
        {
          lat: parseFloat(this.abh.lat),
          lng: parseFloat(this.abh.lng),
        },
        { icon: abhMarkerIcon }
      );

      if (this.currentAbhMarker) {
        this.map.removeObject(this.currentAbhMarker);
      }

      this.currentAbhMarker = abhMarker;
      this.map.addObject(abhMarker);
    }
  }

  private zoomOutMapAfterLocationChanged() {
    var zoom = this.map.getZoom();
    if (zoom >= 7) {
      if (zoom >= 6) {
        zoom = zoom - 1;
      } else {
        zoom = zoom - 2;
      }
      this.map.setZoom(zoom);
    }
    this.map.removeEventListener(
      "mapviewchangestart",
      this.zoomOutMapAfterLocationChanged
    );
  }

  private findNearestPoint(point: H.geo.IPoint) {
    var minDist = Number.MAX_VALUE,
      nearest: H.geo.IPoint | null = null;

    // iterate over objects and calculate distance between them
    for (var i = 0; i < this.points.length; i += 1) {
      var p = H.geo.Point.fromIPoint(this.points[i]);
      var markerDist = p.distance(point);
      if (markerDist < minDist) {
        minDist = markerDist;
        nearest = this.points[i];
      }
    }

    return nearest;
  }

  mounted() {
    this.platform = new H.service.Platform({
      apikey: APP_MAP_API_KEY || "${HERE_MAP_API_KEY}",
      useHTTPS: true,
    });

    var service = this.platform.getOMVService({
      path: "v2/vectortiles/core/mc",
    });

    var languageCode = "ENG";
    switch (this.language) {
      case "de":
        languageCode = "GER";
        break;
      // TODO: Support more languages;
      default:
        languageCode = "ENG";
    }
    var provider = new H.service.omv.Provider(
      service,
      new H.map.Style(
        "https://js.api.here.com/v3/3.1/styles/omv/oslo/normal.day.yaml"
      ),
      { lg: languageCode }
    );

    var defaultLayers = new H.map.layer.TileLayer(provider);

    this.map = new H.Map(<Element>this.$refs["mapContainer"], defaultLayers, {
      center: { lat: 51, lng: 1.0 },
      zoom: 5,
      pixelRatio: window.devicePixelRatio || 1,
    });

    this.$emit("changeCurrentLocation", this.map.getCenter());

    var ui = H.ui.UI.createDefault(this.map, defaultLayers);

    // Instantiate the default behavior, providing the mapEvents object:
    var mapEvents = new H.mapevents.MapEvents(this.map);
    var behavior = new H.mapevents.Behavior(mapEvents);

    this.clusteredDataProvider = this.createClusterProvider();
    this.clusteredDataProvider.setDataPoints(this.points);
    this.clusteredDataProvider.addEventListener("tap", this.onTap);

    // Create a layer that includes the data provider and its data points:
    var layer = new H.map.layer.ObjectLayer(this.clusteredDataProvider);
    this.map.addLayer(layer);
    this.map.addEventListener("mapviewchangeend", this.onMapviewchangeend);

    window.addEventListener("resize", () => {
      this.map.getViewPort().resize();
    });
  }

  private onTap(event) {
    // Log data bound to the marker that has been tapped:
    if (event.target.getData().isCluster()) {
      this.map
        .getViewModel()
        .setLookAtData({ bounds: event.target.getData().getBoundingBox() });
    } else {
      var referencePoint = this.map.getCenter();
      if (this.myLocation !== null) {
        referencePoint = this.myLocation;
      }

      let haendlerEl = document.getElementById(
        "haendler-" + event.target.getData().getData()["id"]
      );
      if (haendlerEl) {
        let letterEl = haendlerEl.getElementsByClassName("noise-icon__text");
        if (letterEl && letterEl.length > 0) {
          let letter = letterEl[0].textContent;

          this.$emit("selectHaendler", {
            letter: letter,
            distance: (
              referencePoint.distance(event.target.getData().getPosition()) /
              1000
            ).toFixed(1),
            data: event.target.getData().getData(),
          });
        }
      }
    }
  }

  private onMapviewchangeend() {
    var noiseMarkers = this.clusteredDataProvider.requestDomMarkers(
      this.map.getViewModel().getLookAtData().bounds.getBoundingBox(),
      this.map.getZoom()
    );

    let referencePoint = this.map.getCenter();
    if (this.myLocation !== null) {
      referencePoint = this.myLocation;
    }

    noiseMarkers.sort(function (a, b) {
      return (
        a.getGeometry().distance(referencePoint) -
        b.getGeometry().distance(referencePoint)
      );
    });

    this.selectedPoints = [];
    var selectedHaendlerInSelectedPoints = false;
    for (var i = 0; i < noiseMarkers.length; i++) {
      var marker = noiseMarkers[i];
      var markerData = marker.getData().getData();
      var letter = String.fromCharCode(65 + i);

      var selectedPoint = {
        letter: letter,
        distance: (
          referencePoint.distance(marker.getGeometry()) / 1000
        ).toFixed(1),
        data: markerData,
      };
      this.selectedPoints.push(selectedPoint);

      let haendlerEl = document.getElementById("haendler-" + markerData["id"]);
      if (haendlerEl) {
        let letterEl = haendlerEl.getElementsByClassName("noise-icon__text");
        if (letterEl && letterEl.length > 0) {
          letterEl[0].textContent = letter;
        }
      }

      if (
        this.selectedHaendler &&
        this.selectedHaendler.data.id === markerData["id"]
      ) {
        selectedHaendlerInSelectedPoints = true;
        this.$emit("selectHaendler", selectedPoint);
      }
    }

    if (this.selectedHaendler && !selectedHaendlerInSelectedPoints) {
      this.selectedHaendler.letter = " ";
      this.$emit("selectHaendler", this.selectedHaendler);
    }

    this.$emit("changeCurrentLocation", this.map.getCenter());
    this.$emit("updatedSelectedPoints", this.selectedPoints);
  }

  private createClusterProvider() {
    return new H.clustering.Provider([], {
      clusteringOptions: {
        eps: 64,
        minWeight: 2,
      },
      theme: {
        getClusterPresentation: (cluster) => {
          // Use cluster weight to change the icon size
          var weight = cluster.getWeight();
          var canvas, textPos;

          if (weight < 10) {
            canvas = this.clusterIcon(this, 28, "51,51,51");
            textPos = { x: 11, y: 18 };
          } else if (weight < 25) {
            canvas = this.clusterIcon(this, 38, "51,51,51");
            textPos = { x: 13, y: 23 };
          } else if (weight < 50) {
            canvas = this.clusterIcon(this, 38, "51,51,51");
            textPos = { x: 13, y: 23 };
          } else if (weight < 100) {
            canvas = this.clusterIcon(this, 38, "51,51,51");
            textPos = { x: 13, y: 23 };
          } else if (weight < 1000) {
            canvas = this.clusterIcon(this, 48, "51,51,51");
            textPos = { x: 15, y: 28 };
          } else {
            canvas = this.clusterIcon(this, 66, "51,51,51");
            textPos = { x: 20, y: 38 };
          }
          var context = canvas.getContext("2d");
          context.fillStyle = "#FFFFFF";
          var fontSize = 11;
          context.font = "bold " + fontSize + "px Arial";
          var testXPos = textPos.x;
          var testYPos = textPos.y;
          context.fillText(weight, testXPos, testYPos);

          var icon = new H.map.Icon(canvas, {
            anchor: {
              x: canvas.width / 2,
              y: canvas.width / 2,
            },
            crossOrigin: false,
          });

          var clusterMarker = new H.map.Marker(cluster.getPosition(), {
            icon: icon,
            min: cluster.getMinZoom(),
            max: cluster.getMaxZoom(),
          });

          // Bind cluster data to the marker
          clusterMarker.setData(cluster);

          return clusterMarker;
        },
        getNoisePresentation: (noisePoint) => {
          var outerElement = document.createElement("div"),
            innerElement = document.createElement("div");

          outerElement.style.userSelect = "none";
          outerElement.style.webkitUserSelect = "none";
          /** @ts-ignore */
          outerElement.style.msUserSelect = "none";
          //outerElement.style.mozUserSelect = 'none';
          outerElement.style.cursor = "default";

          innerElement.style.width = "29px";
          innerElement.style.height = "40px";

          // add negative margin to inner element
          // to move the anchor to center of the div
          innerElement.style.marginTop = "-40px";
          innerElement.style.marginLeft = "-14px";

          outerElement.appendChild(innerElement);

          // Add text to the DOM element
          var svg = this.noiseSvg
            .replace("{text}", "A")
            .replace("{id}", "haendler-" + noisePoint.getData()["id"]);
          innerElement.innerHTML = svg;

          //create dom icon and add/remove opacity listeners
          var domIcon = new H.map.DomIcon(outerElement);

          var marker = new H.map.DomMarker(noisePoint.getPosition(), {
            icon: domIcon,
            min: noisePoint.getMinZoom(),
          });

          marker.setData(noisePoint);
          return marker;
        },
      },
    });
  }

  private clusterIcon(self, size, color) {
    var canvas = document.createElement("canvas");
    var context = canvas.getContext("2d");

    canvas.width = canvas.height = size;

    var center = size / 2;
    if (context) {
      context.beginPath();
      context.strokeStyle = "rgba(" + color + ",0.2)";
      context.fillStyle = "rgba(" + color + ",1)";
      context.arc(center, center, center, 0, 2 * Math.PI, !1);
      context.fill();
    }

    return canvas;
  }
}
